import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import Button from '@adsk/alloy-react-button';
import { useFormik } from 'formik';
import EditCompanyAddress from '@common/EditCompanyAddress';
import { isEmptyObject } from '@common/utils';

const EditAddress = ({
  address,
  index,
  mapBoxAccessToken,
  onAddAddressClick,
  onChange,
  onClose,
  style,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const { setFieldValue, values: unsavedAddress } = useFormik({
    enableReinitialize: true,
    initialValues: { ...address },
  });

  return (
    <div css={{ width: '100%', marginTop: '-20px', ...style }}>
      <EditCompanyAddress
        address={unsavedAddress}
        addAddressDisabled={isEmptyObject(unsavedAddress)}
        mapBoxAccessToken={mapBoxAccessToken}
        onAddAddressClick={() => onAddAddressClick(unsavedAddress, index)}
        onResetAddress={() => {}}
        setFieldValue={setFieldValue}
      />
      <div css={{ width: '100%', textAlign: 'right', marginTop: 20 }}>
        <Button
          onClick={() => onClose(unsavedAddress, index)}
          style={{ marginRight: '15px' }}
          variant={Button.VARIANTS.TERTIARY}
        >
          {T.translate('CANCEL')}
        </Button>
        <Button
          disabled={isEmptyObject(unsavedAddress)}
          onClick={() => onChange(unsavedAddress, index)}
          variant={Button.VARIANTS.PRIMARY}
        >
          {T.translate('SAVE')}
        </Button>
      </div>
    </div>
  );
};

EditAddress.propTypes = {
  address: PropTypes.shape({
    country: PropTypes.string,
    street: PropTypes.string,
    phone: PropTypes.string,
  }),
  index: PropTypes.number.isRequired,
  mapBoxAccessToken: PropTypes.string,
  onAddAddressClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
};

EditAddress.defaultProps = {
  address: {},
  mapBoxAccessToken: '',
  style: {},
};

export default EditAddress;
